import { P2GGrid } from "@parcel2go/peacock-legacy-core/dist/grid";
import { P2GText } from "@parcel2go/peacock-legacy-core/dist/typography";
import { P2GTranslation } from "@parcel2go/peacock-legacy-resources/dist/translations";
import React from "react";
import { TrackingEvent } from '../../services/api/index';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface ITrackingWindowProps {
  event: TrackingEvent
  started?: boolean
  headingVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

const useStyles = makeStyles(() => ({
  textSection: {
    flexDirection: 'column',
    justifyDirection: 'flex-start',
    alignItems: 'stretch',
    marginBottom: '8px'
  }
}))

const TrackingWindow: React.FC<ITrackingWindowProps> = (props) => {

  const classes = useStyles();
  const start = React.useMemo(() => {
    if (props.event.windowStart) {
      return new Date(props.event.windowStart);
    }
    return null;
  }, [props.event]);

  const end = React.useMemo(() => {
    if (props.event.windowEnd) {
      return new Date(props.event.windowEnd);
    }
    return null;
  }, [props.event]);


  if (!start || !end) {
    return null;
  }

  if (props.event.type === "Collection Scheduled" && props.started) {
    return null;
  }

  return (
    <React.Fragment>
      {props.event.type === "Collection Scheduled" &&
        <P2GGrid item container classNames={classes.textSection}>
          <P2GText variant={props.headingVariant}><P2GTranslation translation="TRACKING.RESULT.WINDOW.COLLECTION.TITLE"></P2GTranslation></P2GText>
          <P2GText variant="body1" component='p'>
            <P2GTranslation translation="TRACKING.RESULT.WINDOW.COLLECTION.DESCRIPTION" options={{ date: start.toLocaleDateString('en-GB'), starttime: start.toLocaleTimeString('en-GB'), endtime: end.toLocaleTimeString('en-GB') }} />
          </P2GText>
        </P2GGrid>
      }

      {props.event.type === "Delivery Scheduled" &&
        <P2GGrid item container classNames={classes.textSection}>
          <P2GText variant={props.headingVariant}><P2GTranslation translation="TRACKING.RESULT.WINDOW.DELIVERY.TITLE"></P2GTranslation></P2GText>
          <P2GText variant="body1" component='p'>
            <P2GTranslation translation="TRACKING.RESULT.WINDOW.DELIVERY.DESCRIPTION" options={{ date: start.toLocaleDateString('en-GB'), starttime: start.toLocaleTimeString('en-GB'), endtime: end.toLocaleTimeString('en-GB') }} />
          </P2GText>
        </P2GGrid>
      }
    </React.Fragment>
  );
}

export default TrackingWindow;